import { render } from "./ModalEmbed.vue?vue&type=template&id=b37b3994"
import script from "./ModalEmbed.vue?vue&type=script&lang=js"
export * from "./ModalEmbed.vue?vue&type=script&lang=js"

import "./ModalEmbed.vue?vue&type=style&index=0&id=b37b3994&lang=css"
script.render = render

export default script